import { Subscriber } from './Subscriber';
import { authInterface, setState, versionInfo } from './authorizeImpl';
const globalObject = window;
globalObject.sas = globalObject.sas || {};
if (!globalObject.sas.__authInterface) {
    globalObject.sas.__authInterface = authInterface;
    authInterface.activate();
}
else {
    const auth = globalObject.sas.__authInterface;
    const info = auth.versionInfo;
    let upgrade = false;
    if (info.major < versionInfo.major) {
        upgrade = true;
    }
    else if (info.major === versionInfo.major && info.minor < versionInfo.minor) {
        upgrade = true;
    }
    else if (info.major === versionInfo.major &&
        info.minor === versionInfo.minor &&
        info.patch < versionInfo.patch) {
        upgrade = true;
    }
    if (upgrade) {
        setState(auth._getState());
        auth.deactivate();
        authInterface.activate();
        globalObject.sas.__authInterface = authInterface;
    }
}
function getInterface() {
    return globalObject.sas.__authInterface;
}
export function getAuthorizationInfo(server, authenticationType) {
    var _a;
    const authInterface = getInterface();
    const key = (_a = authInterface.getKey(server, authenticationType)) !== null && _a !== void 0 ? _a : server;
    return authInterface._getState().authMap.get(key);
}
const subscriberMap = new Map();
export function getConnection(server, authenticationType) {
    var _a;
    const key = (_a = getInterface().getKey(server, authenticationType)) !== null && _a !== void 0 ? _a : server;
    const sub = subscriberMap.get(key);
    if (sub) {
        return sub;
    }
    const info = getInterface().addConnection(server, authenticationType);
    const newSub = new Subscriber(info);
    subscriberMap.set(key, newSub);
    getInterface().onStatusChange(server, (status) => {
        newSub.next(status);
    }, authenticationType);
    return newSub;
}
export function getServerStatus(server, authenticationType) {
    var _a;
    return (_a = getAuthorizationInfo(server, authenticationType)) === null || _a === void 0 ? void 0 : _a.status;
}
export function authorize(server, authenticationType) {
    getInterface().authorize(server, authenticationType);
}
export function deauthorize(server, authenticationType) {
    getInterface().deauthorize(server, authenticationType);
}
export function _serverHackOrAuthorized(server, authenticationType) {
    const info = getAuthorizationInfo(server, authenticationType);
    return (info === null || info === void 0 ? void 0 : info.serverHack) || (info === null || info === void 0 ? void 0 : info.status) === 'authorized';
}
export function setKeepAliveInterval(minutes) {
    var _a, _b;
    (_b = (_a = getInterface()).setKeepAliveInterval) === null || _b === void 0 ? void 0 : _b.call(_a, minutes);
}
// for testing
export function _reset() {
    getInterface().deactivate();
    authInterface.activate();
    subscriberMap.clear();
}
//# sourceMappingURL=authorization.js.map